import { Component, OnInit, OnDestroy } from '@angular/core';

import { PlatformService } from 'src/app/services/platform.service';

// config
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-deeplink',
    templateUrl: './deeplink.page.html',
    styleUrls: ['./deeplink.page.scss'],
})
export class DeeplinkPage implements OnInit, OnDestroy {

    constructor(
        public plt: PlatformService
    ) {

    }

    ngOnInit() {

        if (this.plt.is('cordova')) {
            // already inside of cordova app
            // redirect to proper page
            this.plt.applyDeepLink(window.location.search);
        } else {
            // on web, just redirect to proper page in app
            if (!this.plt.is('ios') && !this.plt.is('android')) {
                this.plt.applyDeepLink(window.location.search);
            } else {

                // else try to open mobile app directly via scheme
                // in case associated domain was not working
                if (this.plt.is('android')) {
                    window.location.href = environment.customScheme + '://deeplink' + window.location.search
                }
            }
        }
    }

    downloadApp() {
        if (this.plt.is('ios')) {
            // redirect to app store
            window.location.href = environment.appStoreLink;
        } else {
            window.location.href = environment.playStoreLink;
        }
    }

    openWeb() {
        this.plt.applyDeepLink(window.location.search);
    }

    ngOnDestroy() {

    }

}
